import { createAPI } from "../apisServer";

import BaseUrl from "../baseUrls";

const banco = BaseUrl.dataBase;
const apiServer = createAPI("multiTenant");

const reqConfiguracaoCatalogo = {
	listByEmpresa: async function () {
		return apiServer
			.get("portal/v1/configuracao-catalogo", {
				headers: {
					banco,
				},
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},
	insertUpdate: async function (data) {
		return apiServer
			.post("portal/v1/configuracao-catalogo", data, {
				headers: {
					banco,
				},
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},
};

export default reqConfiguracaoCatalogo;
